import { createContext } from "react";
const AdminCustomerContext = createContext();
export default AdminCustomerContext;
